import { Button, H2 } from '@/common/ui'
import { Info } from 'lucide-react'
import type { PayIdDetails } from '@/wallet/types'
import { WALLET_COPY } from '@/locales/en'
import DepositOptions from './DepositOptions'

interface AddFundsFormProps {
    payIdDetails?: PayIdDetails
    onHavePaidClick: () => void
    onWillTransferLaterClick: () => void
    introText: string
}

export function AddFundsForm({
    payIdDetails,
    onHavePaidClick,
    onWillTransferLaterClick,
    introText,
}: AddFundsFormProps) {
    return (
        <div>
            <H2 className="mb-2">{WALLET_COPY.addFunds.title}</H2>
            <p>{introText}</p>

            <p className="p-4 flex flex-col sm:flex-row items-start sm:items-center gap-3 my-3 bg-muted rounded-tl-3xl rounded-br-3xl">
                <Info size={36} strokeWidth={1} fill="#fff" className="flex-shrink-0" />
                <div>
                    <strong>{WALLET_COPY.addFunds.minimumAmountTitle}</strong>
                    <p className="text-balance">{WALLET_COPY.addFunds.minimumAmountDescription}</p>
                </div>
            </p>

            {payIdDetails && <DepositOptions payIdDetails={payIdDetails} />}

            <div className="flex mt-6 flex-col sm:flex-row gap-5">
                <Button onClick={onHavePaidClick} className="w-full" variant="secondary">
                    {WALLET_COPY.addFunds.havePaid}
                </Button>
                <Button onClick={onWillTransferLaterClick} className="w-full" variant="outline">
                    {WALLET_COPY.addFunds.willTransferLater}
                </Button>
            </div>
        </div>
    )
}
